import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6 text-foreground-950">Strona nie została znaleziona</h1>
        <p className="mt-2 text-base text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-foreground-600">Przepraszamy, ta strona nie istnieje.</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-8 px-6 py-3 text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-left-line text-sm"></i>
          </span>
          Wróć na stronę główną
        </Link>
      </div>
    </div>
  );
}